import styled, { css } from 'styled-components'

type IsMobile = {
  isMobile: boolean
}

export const Container = styled.div<IsMobile>`
  padding: 30px !important;
  width: 366px;
  box-shadow: 0px 1px 7px #00000029;
  border-radius: 30px;
  min-height: 460px;
  height: fit-content;

  ${({ isMobile }) => isMobile && css`
    margin-top: 30px;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: ${isMobile ? '0' : '0 20px'};
    box-shadow: none;
  `}
`

export const LineBreaker = styled.div<IsMobile>`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: center;
  margin-bottom: 10px;

  & > p {
    white-space: nowrap;
    color: #898989;
    margin: 0 10px;
    text-align: center;
  }

  ${({ isMobile }) => isMobile && css`
    position: absolute;
    top: 0;
    & > div {
      width: 100%;
      height: 1px;
      background-color: #E2E2E2;
    }
  `}
`